<template>
  <section class="dashboard-card">
    <header class="dashboard-card-header">
      <div class="flex items-center">
        <VSvgIcon name="orders" />
        <h2 class="dashboard-card-header-heading">{{ $t('dashboard.orders.heading') }}</h2>
      </div>
      <router-link class="dashboard-card-header-link" to="/orders">
        {{ $t('dashboard.orders.action') }}
      </router-link>
    </header>
    <Order :order="lastOrder" />
  </section>
</template>

<script>
import Order from './Order';
import VSvgIcon from '@/components/base/VSvgIcon';

export default {
  name: 'DashboardOrders',
  components: { Order, VSvgIcon },
  props: { lastOrder: Object },
};
</script>
